"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _hooks = require("../../hooks");
var _templateObject;
const _excluded = ["src", "alt", "width", "height", "rounded", "backgroundColor", "fit", "loading", "datasets", "itemProp", "imageComponent", "fallback", "onClick", "onError"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
const defaultProps = {
  width: 100,
  height: 100,
  datasets: {},
  fit: 'cover',
  imageComponent: 'img'
};
const Image = props => {
  const _defaultProps$props = _objectSpread(_objectSpread({}, defaultProps), props),
    {
      src,
      alt,
      width,
      height,
      rounded,
      backgroundColor,
      fit,
      loading,
      datasets,
      itemProp,
      imageComponent,
      fallback,
      onClick,
      onError
    } = _defaultProps$props,
    restOfProps = _objectWithoutProperties(_defaultProps$props, _excluded);
  const [imageUrl, setImageUrl] = (0, _react.useState)(src);
  const dataAttributes = (0, _hooks.useDataset)(datasets);
  const onHandlerError = e => {
    if (fallback) setImageUrl(fallback);
    onError === null || onError === void 0 || onError(e);
  };
  (0, _react.useEffect)(() => {
    if (src) setImageUrl(src);
  }, [src]);
  const _PADDING_PERCENTAGE = 25;
  const _DEFAULT_RADIUS = 7;
  const StyledImage = (0, _styled.default)(imageComponent)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n  "])), _ref => {
    let {
      backgroundColor,
      width,
      height,
      rounded,
      onClick,
      fit
    } = _ref;
    let styles = "\n      border-radius: ".concat(rounded || _DEFAULT_RADIUS, "px;\n      width: ").concat(typeof width === 'string' ? width : "".concat(width, "px"), ";\n      height: ").concat(typeof height === 'string' ? height : "".concat(height, "px"), ";\n      object-fit: ").concat(fit, ";\n    ");
    if ((backgroundColor === null || backgroundColor === void 0 ? void 0 : backgroundColor.length) >= 1) {
      styles += "\n        background-color: ".concat(backgroundColor, ";\n        padding: ").concat(width * _PADDING_PERCENTAGE / 100, "px;\n      ");
    }
    if (onClick) {
      styles += 'cursor: pointer;';
    }
    return styles;
  });
  return /*#__PURE__*/_react.default.createElement(StyledImage, _extends({
    src: imageUrl,
    alt: alt,
    "data-image-is-fallback": imageUrl === fallback,
    width: width,
    rounded: rounded,
    height: height,
    fit: fit,
    onClick: onClick,
    backgroundColor: backgroundColor,
    loading: loading,
    itemProp: itemProp,
    fallback: fallback,
    onError: onHandlerError
  }, restOfProps, dataAttributes));
};
var _default = exports.default = Image;